import { render, staticRenderFns } from "./ModalEnviarMotivoJustificativa.vue?vue&type=template&id=0a8c1658&scoped=true"
import script from "./ModalEnviarMotivoJustificativa.vue?vue&type=script&lang=js"
export * from "./ModalEnviarMotivoJustificativa.vue?vue&type=script&lang=js"
import style0 from "./ModalEnviarMotivoJustificativa.vue?vue&type=style&index=0&id=0a8c1658&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8c1658",
  null
  
)

export default component.exports